import { createApi } from '@reduxjs/toolkit/query/react';
import { TSharedDTO } from '~/types/DTO/shared';
import { baseQuery } from '~/store/apis/baseQuery/baseQuery';
import { ClientAssessmentQuestionnaireTypeId } from '~/enums';
import { getMarketBasedOnHostname } from '~/helpers/utils';

const market = getMarketBasedOnHostname();

export const clientAssessmentApi = createApi({
  reducerPath: 'clientAssessmentApi',
  baseQuery: baseQuery(
    `${import.meta.env.VITE_API_SVC_ONBOARDING_BASE_URL}/country/${market}`
  ),
  endpoints: (build) => ({
    getClientAssessmentQuestions: build.query<
      TSharedDTO['getKYCQuestionsAndAnswersRes'],
      {
        typeId: ClientAssessmentQuestionnaireTypeId;
      }
    >({
      query: ({ typeId }) => ({
        url: `/client-assessment/questions?typeId=${typeId}`,
      }),
    }),
    postClientAssessmentAnswers: build.mutation<
      TSharedDTO['postKYCAnswersRes'],
      {
        clientId: number;
        typeId: ClientAssessmentQuestionnaireTypeId;
        body: TSharedDTO['postKYCAnswersReq'];
      }
    >({
      query: ({ clientId, typeId, body }) => ({
        url: `/client-assessment/answers/${clientId}?typeId=${typeId}`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetClientAssessmentQuestionsQuery,
  usePostClientAssessmentAnswersMutation,
} = clientAssessmentApi;
